import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ImportTemplateService {
  constructor(private readonly http: HttpClient) {}

  downloadTemplate(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  importFile(url: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(url, formData);
  }
}